import { DndProvider as ReactDndProvider } from 'react-dnd';
import { TouchBackend } from 'react-dnd-touch-backend';

export default function GaneDndProvider({ children }) {
  const hasNativeElementsFromPoint =
    document && (document.elementsFromPoint || document.msElementsFromPoint);

  function getDropTargetElementsAtPoint(x, y, dropTargets) {
    return dropTargets.filter((t) => {
      const rect = t.getBoundingClientRect();
      return (
        x >= rect.left && x <= rect.right && y <= rect.bottom && y >= rect.top
      );
    });
  }

  const touchBackendOptions = {
    getDropTargetElementsAtPoint:
      !hasNativeElementsFromPoint && getDropTargetElementsAtPoint,
    enableKeyboardEvents: false,
    ignoreContextMenu: true,
    touchSlop: 10,
    scrollAngleRanges: [{ start: 300 }, { end: 60 }, { start: 120, end: 240 }],
  };

  return (
    <ReactDndProvider backend={TouchBackend} options={touchBackendOptions}>
      {children}
    </ReactDndProvider>
  );
}
